import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function currentAudioReducer(state = initialState.currentAudioId, action) {
    switch(action.type){
        case types.SET_CURRENT_AUDIO_ID:
            //debugger;
            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new stateconsole.log('UPDATE_PROJECT_SUCCESS')
            return action.currentAudioId;

        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/currentAudioReducer.js
 **/